module.exports = __webpack_public_path__ + "static/media/img_hourly_03.e335bac5.png";